export * from './TextPassage';
